import { useEffect, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';
import './Marketwidgets.css';

function ScreenerWidget({ type, isDark }) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    node.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-screener.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      width: '100%',
      height: '400',
      defaultColumn: 'overview',
      defaultScreen: type === 'gainers' ? 'top_gainers' : 'top_losers',
      market: 'india',
      showToolbar: false,
      colorTheme: isDark ? 'dark' : 'light',
      locale: 'en',
      isTransparent: true,
    });
    node.appendChild(script);

    return () => {
      node.innerHTML = '';
    };
  }, [isDark, type]);

  return <div ref={ref} className="tv-widget-wrap" />;
}

function OverviewWidget({ isDark }) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    node.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      colorTheme: isDark ? 'dark' : 'light',
      dateRange: '1D',
      showChart: true,
      locale: 'en',
      isTransparent: true,
      showSymbolLogo: true,
      showFloatingTooltip: false,
      width: '100%',
      height: '400',
      tabs: [
        {
          title: 'Global Markets',
          symbols: [
            { s: 'BSE:SENSEX', d: 'SENSEX' },
            { s: 'INDEX:HSI', d: 'Hang Seng' },
          ],
          originalTitle: 'Global Markets',
        },
        {
          title: 'Crypto',
          symbols: [
            { s: 'BINANCE:BTCUSDT', d: 'Bitcoin' },
            { s: 'BINANCE:ETHUSDT', d: 'Ethereum' },
            { s: 'BINANCE:SOLUSDT', d: 'Solana' },
          ],
          originalTitle: 'Crypto',
        },
      ],
    });
    node.appendChild(script);

    return () => {
      node.innerHTML = '';
    };
  }, [isDark]);

  return <div ref={ref} className="tv-widget-wrap" />;
}

function MarketWidgets() {
  const { isDark } = useTheme();

  return (
    <section className="mw-section">
      <div className="mw-inner">

        {/* HEADER */}
        <div className="mw-header">
          <div className="mw-eyebrow">NSE India · Live Market Data</div>
          <h2 className="mw-title">Today's <span>Market Movers</span></h2>
          <p className="mw-sub">Real-time data powered by TradingView · Updates live during market hours</p>
        </div>

        {/* GAINERS & LOSERS ROW */}
        <div className="mw-gl-grid">
          <div className="mw-panel">
            <div className="mw-panel-head gainers">
              <span>📈</span>
              <span className="mw-panel-title">Top Gainers · NSE</span>
            </div>
            <div className="mw-widget-box">
              <ScreenerWidget type="gainers" isDark={isDark} />
            </div>
          </div>

          <div className="mw-panel">
            <div className="mw-panel-head losers">
              <span>📉</span>
              <span className="mw-panel-title">Top Losers · NSE</span>
            </div>
            <div className="mw-widget-box">
              <ScreenerWidget type="losers" isDark={isDark} />
            </div>
          </div>
        </div>

        {/* MARKET OVERVIEW */}
        <div className="mw-overview-wrap">
          <div className="mw-panel">
            <div className="mw-panel-head overview">
              <span>📊</span>
              <span className="mw-panel-title">Market Overview</span>
              <span className="mw-panel-sub">Indices · Top Stocks · Crypto</span>
            </div>
            <div className="mw-widget-box">
              <OverviewWidget isDark={isDark} />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="mw-footer">
          <span className="mw-live-dot"></span>
          Live NSE data · TradingView · Market hours 9:15 AM – 3:30 PM IST · For educational purposes
        </div>

      </div>
    </section>
  );
}

export default MarketWidgets;